import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-screenaccesscontroltwo',
  templateUrl: './usr-screenaccesscontroltwo.component.html',
  styleUrls: ['./usr-screenaccesscontroltwo.component.css']
})
export class UsrScreenaccesscontroltwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
